import { render, staticRenderFns } from "./createAdminFranchiseDoctor.vue?vue&type=template&id=5174eb5a&scoped=true&"
import script from "./createAdminFranchiseDoctor.vue?vue&type=script&lang=js&"
export * from "./createAdminFranchiseDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174eb5a",
  null
  
)

export default component.exports